export enum BuildingType {
  MULTIFAMILY = 'Multifamily',
  SINGLE_FAMILY = 'Single family',
}

export enum DataType {
  PORTFOLIO_TOTAL = 'Portfolio total',
  MARKET_AVERAGE = 'Portfolio avg & market median',
}
